/**
 * @file Patient Profile Page — /mi-perfil-paciente
 */
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { usePatientProfile } from "../hooks/usePatients";
import { PATIENT_STRINGS } from "../constants/strings";
import { Button, Card, CardHeader, Input, Spinner } from "../ui";
import "./PatientProfile.css";

const validationSchema = Yup.object({
  dateOfBirth: Yup.date().nullable(),
});

export default function PatientProfile() {
  const { profile, isLoading, updateProfile } = usePatientProfile();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      dateOfBirth: profile?.dateOfBirth
        ? new Date(profile.dateOfBirth).toISOString().split("T")[0]
        : "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        dateOfBirth: values.dateOfBirth ? new Date(values.dateOfBirth).toISOString() : null,
      };
      await updateProfile(data);
    },
  });

  if (isLoading) {
    return (
      <div className="pf-page">
        <div className="pf-loading">
          <Spinner size={28} />
        </div>
      </div>
    );
  }

  const fullName = `${profile?.user?.firstName || ""} ${profile?.user?.lastName || ""}`.trim();

  return (
    <div className="pf-page">
      <header className="pf-head">
        <span className="pf-eyebrow">Mi perfil</span>
        <h1 className="pf-title">{PATIENT_STRINGS.TAB_PROFILE}</h1>
      </header>

      <form onSubmit={formik.handleSubmit} className="pf-form">
        <Card>
          <CardHeader title={PATIENT_STRINGS.PERSONAL_INFO} />
          <div className="pf-fields">
            <Input label="Nombre" value={fullName} readOnly disabled />
            {profile?.user?.email && (
              <Input label="Correo electrónico" value={profile.user.email} readOnly disabled />
            )}
            <Input
              type="date"
              label={PATIENT_STRINGS.DATE_OF_BIRTH}
              {...formik.getFieldProps("dateOfBirth")}
            />
          </div>
        </Card>

        <Button type="submit" size="lg" fullWidth loading={formik.isSubmitting}>
          {PATIENT_STRINGS.SAVE}
        </Button>
      </form>
    </div>
  );
}
